<template>
  <div class="message-wrapper">
    <div v-if="messageData.author === 'asistent'" class="message-header">
      <img src="@/assets/newImges/smLogo.svg" alt="" />
      <span>{{ $t("chatBot.Assistant") }}</span>
      <!-- messageData.author  -->
    </div>
    <!-- class="message" -->
    <div v-if="messageData.text && messageData.text[activeLocale]">
      <div
        class="message"
        :class="{ assistent: messageData.author === 'asistent' }"
        v-for="(part, index) in messageData.text[activeLocale]"
        :key="index"
      >
        <template v-if="loaded === index">
          <div class="part">
            <div class="loader-custom"></div>
          </div>
        </template>
        <template v-if="loaded > index">
          <template v-if="typeof part === 'object' && part.type === 'link'">
            <div class="part">
              <router-link :to="{ name: part.href }">
                {{ part.text[activeLocale][0] }}
              </router-link>
            </div>
          </template>
          <template
            v-else-if="typeof part === 'object' && part.type === 'image'"
          >
            <div class="part">
              <a
                :href="baseUrl + part.src"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img :src="baseUrl + part.src" alt="" />
              </a>
            </div>
          </template>
          <template v-else>
            <div class="part">
              {{ part }}
            </div>
          </template>
        </template>
      </div>
    </div>
    <div
      v-if="
        messageData.items &&
          messageData.items.length > 0 &&
          (!this.messageData.text ||
            loaded >= this.messageData.text[this.activeLocale].length)
      "
      class="items-wrapper"
    >
      <div
        v-for="(option, index) in messageData.items"
        :key="index"
        class="option"
        @click="$emit('optionSelected', option)"
      >
        <span v-for="(part, index) in option.label[activeLocale]" :key="index">
          {{ part }}
        </span>
      </div>
      <div
        v-if="messageData.parent"
        class="option"
        @click="
          $emit('optionSelected', {
            id: messageData.parent,
            label: { sr: ['Nazad'] }
          })
        "
      >
        <span>
          {{ $t("chatBot.back") }}
          <!-- Nazad -->
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { baseURL } from "@/api";
export default {
  name: "chat-bot-message",
  props: {
    messageData: {
      type: Object,
      required: true
    },
    interval: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: 0,
      baseUrl: baseURL
    };
  },
  computed: {
    activeLocale() {
      if (this.$i18n.locale === "de") {
        return "en";
      }
      return this.$i18n.locale;
      // return "sr";
    }
  },
  methods: {
    scrollToBottom() {
      let el = document.querySelector(".messages-wrapper");
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    }
  },
  mounted() {
    if (this.messageData.author === "asistent") {
      var interval = setInterval(
        () => {
          this.loaded++;
          this.$nextTick(() => {
            setTimeout(
              () => {
                this.scrollToBottom();
              },
              this.interval ? 0 : 50
            );
          });
          if (
            !this.messageData.text ||
            this.loaded >= this.messageData.text[this.activeLocale].length
          ) {
            clearInterval(interval);
          }
        },
        this.interval ? 0 : 2500
      );
    } else {
      this.loaded = 999;
    }
  }
};
</script>
<style lang="scss">
.message-wrapper {
  display: flex;
  flex-direction: column;

  .message-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;

    img {
      width: 25px;
      margin-right: 10px;
    }
    span {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      color: #bdb7b7;
      text-transform: capitalize;
    }
  }

  .message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .part {
      padding: 7px 15px;
      margin-left: 35px;
      background: #823a4c;
      border-radius: 9px;
      margin-bottom: 17px;
      border-top-right-radius: 0px;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #ffffff;
      text-align: left;
      align-self: flex-end;
      min-height: 30px;
      box-sizing: border-box;

      img {
        max-width: 280px;
      }
    }
  }
  .message.assistent {
    align-items: flex-end;
    .part {
      border-top-left-radius: 0px;
      border-top-right-radius: 9px;
      color: #3f3f3f;
      background: #fff6f6;
      align-self: flex-start;
    }
  }

  .items-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    .option {
      border: 1px solid #823a4c;
      min-height: 25px;
      display: flex;
      align-items: center;
      border-radius: 20px;
      line-height: 25px;
      font-weight: 700;
      font-size: 16px;
      color: #823a4c;
      padding: 0 15px;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 12px;
      font-size: 12px;
      line-height: 16px;
      text-transform: uppercase;
      background: linear-gradient(
        180deg,
        rgba(255, 246, 246, 0.65) 0%,
        rgba(217, 217, 217, 0) 100%
      );
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.08));
    }
  }
}
.loader-custom {
  margin-left: -10px;
  margin-right: -10px;
  width: 50px;
  height: 16px;
  background: radial-gradient(
      circle 2px at 2px center,
      #823a4c,
      100%,
      transparent 0
    ),
    radial-gradient(circle 2px at 2px center, #823a4c, 100%, transparent 0);
  background-size: 10px 16px;
  background-repeat: no-repeat;
  position: relative;
  animation: ballX 1s linear infinite;
}
.loader-custom:before {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #823a4c;
  inset: 0;
  margin: auto;
  animation: moveX 1s cubic-bezier(0.5, 100, 0.5, -200) infinite;
}
@keyframes ballX {
  0%,
  25%,
  50%,
  75%,
  100% {
    background-position: 25% 0, 75% 0;
  }
  40% {
    background-position: 25% 0, 85% 0;
  }
  90% {
    background-position: 15% 0, 75% 0;
  }
}
@keyframes moveX {
  100% {
    transform: translate(0.15px);
  }
}
</style>
